module.exports = __webpack_public_path__ + "static/demilich-ed05269ae769762e1bc8168564abc307.jpg";